<template>
  <div>
    <div class="m_flex_row" style="margin:30px">
      搜索关键词(姓名、手机号)：
      <a-input
        placeholder="请输入搜索关键词："
        @change="nameChange"
        v-model="key"
        style="width:300px;margin-left:20px;margin-right:100px;"
      />

      <a-button type="primary" icon="search" style="margin-right:50px">搜索</a-button>

      <a-button type="primary" icon="plus" @click="goAddProject">创建用户</a-button>
    </div>

    <a-table :columns="columns" :dataSource="data" bordered :pagination="false">
      <template slot="operation" slot-scope="text, record">
        <a-popconfirm
          v-if="!record.is_delete"
          title="确定删除该数据吗?"
          @confirm="() => onDelete(record.key)"
        >
          <a href="javascript:;">删除</a>
        </a-popconfirm>
        <a-popconfirm v-else title="确定将删除的数据找回吗？" @confirm="() => getBack(record.key)">
          <a href="javascript:;">找回</a>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a @click="() => edit(record.key)">编辑</a>
      </template>
    </a-table>
    <div style="text-align:center;margin-top:30px;">
      <a-pagination :total="total" @change="changePage" show-less-items />
    </div>
  </div>
</template>
<script>
import request from "../../utils/request";
const columns = [
  {
    title: "姓名",
    dataIndex: "name",
    width: "20%",
  },
  {
    title: "手机号",
    dataIndex: "phone",
    width: "20%",
  },
  {
    title: "性别",
    dataIndex: "sex_text",
    width: "10%"
  },
  {
    title: "权限身份",
    dataIndex: "authority_text",
    width: "10%"
  },
  {
    title: "用户状态",
    dataIndex: "is_delete_text",
    width: "10%"
  },
  {
    title: "创建时间",
    dataIndex: "create_time",
    width: "10%"
  },
  {
    title: "操作",
    width: "10%",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" }
  }
];

export default {
  data() {
    return {
      key: "",
      total: 0,
      current_page: 0,
      data: [],
      columns,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    changePage(page, pageSize) {
      this.current_page = page - 1;
      console.log(page, pageSize, this.current_page);
      this.getData();
    },
    nameChange(e) {
      console.log(this.key, e);
      this.getData();
    },
    goAddProject() {
      this.$router.push({
        path: "/user/manager/add"
      });
    },
    getData() {
      request({
        url: "/user/all/",
        method: "get",
        params: {
          page: this.current_page,
          page_size: 10,
          key: this.key
        }
      }).then(response => {
        if (response.data.success) {
          const list = response.data.data;
          let i = this.current_page * 10 + 1;

          this.data = list.map(item => {
            item["the_id"] = i;
            i += 1;
            return item;
          });
          this.total = response.data.total;
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    handleSearch(selectedKeys, confirm) {
      confirm();
      this.searchText = selectedKeys[0];
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    onDelete(key) {
      request({
        url: "/user/" + key + "/",
        method: "delete",
        params: {}
      }).then(response => {
        console.log("111");
        if (response.data.success) {
          this.getData();
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    getBack(key) {
      request({
        url: "/user/getback/" + key,
        method: "put",
        params: {}
      }).then(response => {
        this.getData();
      });
    },

    edit(key) {
      this.$router.push({ path: "/user/manager/add", query: { the_id: key } });
    },
  }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style